import React from 'react';

/** Shown on embeds when plan requires branding (Free / Small). */
export default function BrandingFooter() {
  return (
    <div
      className="flex items-center justify-center gap-2 py-2 text-xs border-t"
      style={{
        borderColor: 'var(--sw-border)',
        color: 'var(--sw-muted)',
        background: 'var(--sw-surface)',
      }}
    >
      <span className="font-bold text-[10px] uppercase tracking-wider" style={{ color: 'var(--sw-accent)' }}>
        SW
      </span>
      <span>Powered by Scorewidget</span>
    </div>
  );
}
